<template>
  <div v-if="hasContent" class="next-step-strip small mt-1">
    <b-badge v-if="holdBadge" :variant="holdBadge.variant" class="mr-2">
      {{ holdBadge.label }}
    </b-badge>
    <span v-if="nextLabel" class="text-dark">
      Next: <strong>{{ nextLabel }}</strong>
    </span>
  </div>
</template>

<script>
export default {
  name: "NextStepStrip",

  props: {
    processingReadiness: {
      type: Object,
      default: null
    }
  },

  computed: {
    nextLabel: function () {
      const pr = this.processingReadiness;
      if (!pr) {
        return null;
      }
      if (pr.complete) {
        return "Complete";
      }
      if (pr.nextStep && pr.nextStep.label) {
        return pr.nextStep.label;
      }
      return pr.nextCommand || null;
    },
    holdBadge: function () {
      const cls = this.processingReadiness && this.processingReadiness.holdClass;
      if (cls === "outcome_unknown") {
        return { variant: "danger", label: "Outcome unclear — do not post again" };
      }
      if (cls === "reconciliation_hold") {
        return { variant: "warning", label: "Posted — finish records only" };
      }
      if (cls === "fixable") {
        return { variant: "light", label: "Needs a fix first" };
      }
      return null;
    },
    hasContent: function () {
      return !!(this.nextLabel || this.holdBadge);
    }
  }
};
</script>
